(() => {
  const cleanVariantLabels = scope => {
    const rootScope = scope && scope.querySelectorAll ? scope : document;
    rootScope.querySelectorAll('[data-product-root] [data-variant-pill]').forEach(pill => {
      const raw = (pill.textContent || '').trim();
      const marker = raw.lastIndexOf(' · ');
      if (marker > 0) pill.textContent = raw.slice(0, marker).trim();
    });
  };

  const syncBuyNowFromQuantity = input => {
    const root = input && input.closest ? input.closest('[data-product-root]') : null;
    if (!root) return;

    const select = root.querySelector('[data-variant-select]');
    const hidden = root.querySelector('.cs2-product-form input[name="id"]');
    const variantId = select ? select.value : (hidden ? hidden.value : '');
    let available = true;

    if (select && select.selectedOptions && select.selectedOptions[0]) {
      available = select.selectedOptions[0].dataset.available !== 'false';
    }

    const quantity = Math.max(1, parseInt(input.value, 10) || 1);

    root.querySelectorAll('[data-buy-now]').forEach(link => {
      if (!select) available = link.dataset.currentAvailable !== 'false';
      if (variantId && available) {
        link.href = `${link.dataset.cartRoot}/${variantId}:${quantity}?checkout`;
        link.classList.remove('is-disabled');
        link.setAttribute('aria-disabled', 'false');
      } else {
        link.href = '#';
        link.classList.add('is-disabled');
        link.setAttribute('aria-disabled', 'true');
      }
    });
  };

  const init = scope => {
    cleanVariantLabels(scope || document);
    const rootScope = scope && scope.querySelectorAll ? scope : document;
    rootScope.querySelectorAll('[data-product-root] .cs2-product-form input[name="quantity"]').forEach(syncBuyNowFromQuantity);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('input', event => {
    if (event.target.matches('[data-product-root] .cs2-product-form input[name="quantity"]')) {
      syncBuyNowFromQuantity(event.target);
    }
  });

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
